import { Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRoleNames } from 'src/app/core/models/users';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-user-advance-view',
  templateUrl: './user-advance-view.component.html',
  styleUrl: './user-advance-view.component.scss'
})
export class UserAdvanceViewComponent {

  private userService = inject(UserService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);

  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isGlobalAdmin = this.loggedInUserRole == UserRoleNames.GlobalAdmin;
  selectedUser: string = this.userService.activeUserName();
  @Output() hideDetails = new EventEmitter();
  @Output() handleAction = new EventEmitter();
  @ViewChild(MatSort) sort: MatSort;
  
  cloudType: string = this.route.snapshot.params["cloudType"] || this.route.parent.snapshot.params["cloudType"];
  toShow: boolean;
  active = 1;
  actionButtons : {label: string, action: string}[] = [
    { label: 'Reset Password', action: 'Reset' },
    { label: 'Edit User', action: 'Edit' },
    { label: 'Notification', action: 'Notify' },
    { label: 'Delete User', action: 'Delete' },
  ]

  authType: number = this.authenticationService.getAuthenticationType() || 0;

  constructor() { }

  ngOnInit(): void {
    if(this.authType != 0){
      this.actionButtons = this.actionButtons.filter(x => x.action != 'Reset');
    }
  }

  close() {
    this.hideDetails.emit('true');
  }
  
  //openDetails() {
  //  this.active = 1
  //  this.router.navigate([this.selectedUser], {
  //    relativeTo: this.route,
  //  });
  //}

  openAccessControl() {
    this.active = 2;
    this.router.navigate([this.selectedUser, "access-control"], {
      relativeTo: this.route,
    });
  }

  emitAction(action: any) {
    this.handleAction.emit(action);
  }
}
